import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import clientContext from './modules/clientContext/clientContext';
import clientManagement from './modules/clientsManagement/clientsManagement';
import applicationContext from './modules/applicationContext/applicationContext';
import alertHandling from './modules/alertHandling';

Vue.use(Vuex);
const store = new Vuex.Store({
	modules: {
		auth,
		applicationContext,
		clientContext,
		alertHandling,
		clientManagement,
	},
	state: {
		drawer: null,
		appLoading: false,
	},
	mutations: {
		SET_DRAWER(state, isToggled) {
			state.drawer = isToggled;
		},
		SET_APP_LOADING(state, isLoading) {
			state.appLoading = isLoading;
		},
	},
	getters: {
		GET_APP_LOADING(state) {
			return state.appLoading;
		},
	},
});

export default store;
